import { FormGroup, FormControl, ValidatorFn, FormArray, AbstractControl } from '@angular/forms';


export function phoneNumberMasking(): any {
  return ['+', "1", " ", "(", /(?!1)\d/, /\d/, /\d/, ")", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/];
}
export function OntarioMasking(): any {
  return [/\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, "-", /[a-zA-Z]/, /[a-zA-Z]/];
}
export function BCMasking(): any {
  return [/\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/];
}
export function AlbertaMasking(): any {
  return [/\d/, /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/];
}
export function OtherMasking(): any {
  return false;
}
export function otpMasking(): any {
  return [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
}


export function emailValidator(control: FormControl): { [key: string]: any } {
  let emailRegexp = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/;
  if (control.value && !emailRegexp.test(control.value)) {
    return { invalidEmail: true };
  }
  return null as any;
}
export function phoneValidator(control: FormControl): { [key: string]: any } {
  let { value } = control;
  if (value) {
    let newValue = value.replace(/_/g, "")
    if (newValue.substring(8, 9) == " ") {
      let val = newValue.split('');
      val.splice(8, 1);
      val = val.join().replace(/,/g, '');
      newValue = val;
    }
    if (newValue.length != 16 && value.length > 0) {
      return { invalidPhone: true };
    }
  }
  return null as any;
}
// export function passwordValidator(control: FormControl): { [key: string]: any } {
//   let passwordRegexp = /^(?=(.*\d.*){1,})(?=(.*[a-zA-Z].*){6,}).{7,30}$/;
//   if (control.value && !passwordRegexp.test(control.value)) {
//     return { invalidPassword: true };
//   }
//   return null as any;
// }
export function nameValidator(control: FormControl): { [key: string]: any } {
  let nameRegexp = /^[^-\s][a-zA-Z_\s-]+$/;
  if (control.value && !nameRegexp.test(control.value)) {
    return { nameValidator: true };
  }
  return null as any;
}
export function spaceValidator(control: FormControl): { [key: string]: any } {
  let nameRegexp = /^[^\s].*/;
  if (control.value && !nameRegexp.test(control.value)) {
    return { spaceValidator: true };
  }
  return null as any;
}
export function alphaNumeric(control: FormControl): { [key: string]: any } {
  let nameRegexp = /^([^-\s][a-zA-Z0-9 _-]+)$/;
  if (control.value && !nameRegexp.test(control.value)) {
    return { alphaNumeric: true };
  }
  return null as any;
}

export function inventoryType(control: FormControl): { [key: string]: any } {
  let nameRegexp = /^([^-\s][a-zA-Z0-9 *]+)$/;
  if (control.value && !nameRegexp.test(control.value)) {
    return { inventoryType: true };
  }
  return null as any;
}

export function numericAlpha(control: FormControl): { [key: string]: any } {
  let nameRegexp = /^[a-zA-Z0-9 ]*$/;
  if (control.value && !nameRegexp.test(control.value)) {
    return { numericAlpha: true };
  }
  return null as any;
}

export function termsConditionValidator(control: FormControl): { [key: string]: any } {
  if (!control.value) {
    return { termsConditionValidator: true };
  }
  return null as any;
}
export function canceltermsConditionValidator(control: FormControl): { [key: string]: any } {
  if (!control.value) {
    return { canceltermsConditionValidator: true };
  }
  return null as any;
}

export function matchingPasswords(passwordKey: string, passwordConfirmationKey: string) {
  return (group: FormGroup) => {
    let password = group.controls[passwordKey];
    let passwordConfirmation = group.controls[passwordConfirmationKey];
    if (password.value !== passwordConfirmation.value) {
      return passwordConfirmation.setErrors({ mismatchedPasswords: true })
    }
  }
}
export function dateLessThan(from: string, to: string): { [key: string]: any } {
  return (group: FormGroup) => {
    let f = group.controls[from];
    let fromDate = f.value;
    let fromDateConverted = new Date(fromDate);

    let t = group.controls[to];
    let toDate = t.value;
    let toDateConverted = new Date(toDate);
    if (fromDateConverted > toDateConverted) {
      return t.setErrors({ dateLessThan: true });
    }
    else if (fromDateConverted < toDateConverted || !(fromDate && toDate)) {
      f.setErrors(null);
      t.setErrors(null);
    }
    else {
      return null;
    }
  }
}
export function dateLessThanWhenRequired(from: string, to: string): { [key: string]: any } {
  return (group: FormGroup) => {
    let f = group.controls[from];
    let fromDate = f.value;
    let fromDateConverted = new Date(fromDate);

    let t = group.controls[to];
    let toDate = t.value;
    let toDateConverted = new Date(toDate);
    if (fromDate && toDate) {
      if (fromDateConverted > toDateConverted) {
        return t.setErrors({ dateLessThan: true });
      }
      else if (fromDateConverted < toDateConverted || !(fromDate && toDate)) {
        f.setErrors(null);
        t.setErrors(null);
      }
      else {
        return null;
      }
    }
  }
}
export function timeLessThan(from: string, to: string): { [key: string]: any } {
  return (group: FormGroup) => {
    let f = group.controls[from];
    let fromDate = f.value;
    let fromDateConverted = new Date(fromDate);

    let t = group.controls[to];
    let toDate = t.value;
    let toDateConverted = new Date(toDate);
    if (fromDateConverted > toDateConverted) {
      return t.setErrors({ timeLessThan: true });
    }
    else if (fromDateConverted < toDateConverted || !(fromDate && toDate)) {
      f.setErrors(null);
      t.setErrors(null);
    }
    else {
      return null;
    }
  }
}
export function timeLessThanWhen(from: string, to: string): { [key: string]: any } {
  return (group: FormGroup) => {
    let f = group.controls[from];
    let fromDate = f.value;
    let fromDateConverted = new Date(fromDate);

    let t = group.controls[to];
    let toDate = t.value;
    let toDateConverted = new Date(toDate);
    if (toDate && fromDate) {
      if (fromDateConverted > toDateConverted) {
        return t.setErrors({ timeLessThan: true });
      }
      else if (fromDateConverted < toDateConverted || !(fromDate && toDate)) {
        f.setErrors(null);
        t.setErrors(null);
      }
      else {
        return null;
      }
    }
  }
}
export function fileSize(control: FormControl): { [key: string]: any } {
  const file = control.value;
  if (file > 2097152) {
    return { fileSize: true };
  }
  return null as any;
}
export function arrayMinLengthByKey(min: number, boolKey: string): ValidatorFn | any {
  return (control: AbstractControl[]) => {
    if (!(control instanceof FormArray)) {
      return;
    }
    if ((control instanceof FormArray) && control.length > 0 && control.value.filter((f: any) => f[boolKey]).length < min) {
      return { minLengthByKey: true };
    }
    return control.length < min ? { minLength: true } : null;
  }
}
export function arrayMinLength(min: number): ValidatorFn | any {
  return (control: AbstractControl[]) => {
    if (!(control instanceof FormArray)) return;
    return control.length < min ? { minLength: true } : null;
  }
}

export function arrayMaxLength(max: number): ValidatorFn | any {
  return (control: AbstractControl[]) => {
    if (!(control instanceof FormArray)) return;
    return control.length > max ? { maxLength: true } : null;
  }
}
export function dateGreaterThanCurrentDate(control: FormControl): { [key: string]: any } {
  const value = control.value && new Date(control.value);
  let date = new Date();
  if (value) {
    if (new Date(value.getFullYear(), value.getMonth(), value.getDate(), 0, 0, 0) < new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0)) {
      return { dateGreaterThanCurrentDate: true };
    }
  }
  return null as any;
}

export function timeGreaterThanCurrentTime(AC: FormGroup) {
  let date = AC.value.date;
  let time = AC.value.time;
  let newDate = new Date();
  if ((typeof date == 'object') && (time < new Date()) && (new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0).toString() === new Date(newDate.getFullYear(), newDate.getMonth(), newDate.getDate(), 0, 0, 0).toString())) {
    return { "timeGreaterThanCurrentTime": true }
  }
  else {
    return null;
  }
}
